export const UploadFileTypes = {
  pdf: 'application/pdf',
  png: 'image/*'
}
